import { Link } from "react-router-dom";
import logo from "@/assets/logo.webp";

interface FooterProps {
  variant?: "full" | "minimal";
}

export function Footer({ variant = "full" }: FooterProps) {
  if (variant === "minimal") {
    return (
      <footer className="py-8 px-4 border-t border-border bg-background">
        <div className="container mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <img src={logo} alt="Trouve un médiateur" width={32} height={32} loading="lazy" decoding="async" className="h-8 w-8 object-contain" />
            <span className="text-sm font-medium text-foreground">Trouve un Médiateur</span>
          </div>
          <nav aria-label="Liens utiles" className="flex items-center flex-wrap gap-4">
            <Link to="/conditions" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              CGU
            </Link>
            <Link to="/confidentialite" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              Confidentialité
            </Link>
            <Link to="/contact" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              Contact
            </Link>
          </nav>
          <p className="text-xs text-muted-foreground">
            © 2026 Trouve un Médiateur
          </p>
        </div>
      </footer>
    );
  }

  return (
    <footer className="bg-primary text-primary-foreground py-12">
      <div className="container mx-auto px-4 text-center">
        <div className="flex items-center justify-center space-x-3 mb-4">
          <img src={logo} alt="Trouve un médiateur" width={64} height={64} loading="lazy" decoding="async" className="h-16 w-16 object-contain" />
          <div>
            <span className="text-xl font-bold">Trouve un Médiateur</span>
            <p className="text-sm opacity-80">Dialogue & Solution</p>
          </div>
        </div>
        <p className="opacity-90 mb-4">Connecter les communautés avec l'expertise en médiation</p>
        <nav aria-label="Services de médiation" className="flex justify-center flex-wrap gap-6 mb-4">
          <Link to="/mediation-voisinage" className="text-sm opacity-90 hover:opacity-100 underline underline-offset-2">
            Médiation de voisinage
          </Link>
          <Link to="/mediation-travail" className="text-sm opacity-90 hover:opacity-100 underline underline-offset-2">
            Médiation du travail
          </Link>
          <Link to="/mediation-familiale" className="text-sm opacity-90 hover:opacity-100 underline underline-offset-2">
            Médiation familiale
          </Link>
        </nav>
        <nav aria-label="Liens utiles" className="flex justify-center flex-wrap gap-6 mb-4">
          <Link to="/faq" className="text-sm opacity-90 hover:opacity-100 underline underline-offset-2">
            FAQ
          </Link>
          <Link to="/contact" className="text-sm opacity-90 hover:opacity-100 underline underline-offset-2">
            Contact
          </Link>
          <Link to="/conditions" className="text-sm opacity-90 hover:opacity-100 underline underline-offset-2">
            CGU
          </Link>
          <Link to="/confidentialite" className="text-sm opacity-90 hover:opacity-100 underline underline-offset-2">
            Confidentialité
          </Link>
          <Link to="/association" className="text-sm opacity-90 hover:opacity-100 underline underline-offset-2">
            Associations
          </Link>
        </nav>
        <p className="text-sm opacity-75">© 2026 Trouve un Médiateur. Rendre la médiation accessible à tous.</p>
      </div>
    </footer>
  );
}
